// src/AboutSection.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

const AboutSection = () => {
  return (
    <div className="about-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">
            <div className="about-text-centered">
              <h1>About Luxe Unbounded</h1>
              <p className="subtitle">A Travel Unbounded Initiative</p>
              <div className="about-divider" />
              <p className="description-about">
                <span style={{fontWeight:'bold'}}>A smarter way to enjoy second home ownership</span> — designed for discerning travelers.
              </p>
              <p className="description-about">
                Club membership represents a financial investment and is <span style={{fontWeight:'bold'}}>exclusively available</span> to high-net-worth individuals and sophisticated investors.
              </p>
              <p className='description-about'>
                Access to an expanding collection of meticulously curated villas in some of the world's most sought-after destinations — <span style={{fontWeight:'bold'}}>at a fraction of the usual cost.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
